module.exports = __webpack_public_path__ + "img/plumbing-repair-03.4a9aa2e0.jpg";